import script from "./LanguageSwitcher.vue?vue&type=script&setup=true&lang=ts"
export * from "./LanguageSwitcher.vue?vue&type=script&setup=true&lang=ts"

import "./LanguageSwitcher.vue?vue&type=style&index=0&id=9b6782d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9b6782d6"]])

export default __exports__